import { createSlice } from '@reduxjs/toolkit';

const themeSlice = createSlice({
  name: 'theme',
  initialState: {
    mode: localStorage.getItem('theme') !== null ? localStorage.getItem('theme') : 'light' , // Attempt to fetch from localStorage
  },
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
      localStorage.setItem('theme', state.mode); // Store the current theme in localStorage
    },
    setTheme: (state, action) => {
      state.mode = action.payload; // Explicitly set theme mode
    },
  },
});

export const { toggleTheme, setTheme } = themeSlice.actions;
export default themeSlice.reducer;